import { Component } from '@angular/core';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { TitleChangeService } from 'projects/apna-lib/src/lib/services/title-change.service';

@Component({
  selector: 'fa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ForeignAdmits';
  constructor(
    private config: ConfigService,
    private titleService: TitleChangeService
  ) {
    // this.config.getAllConfig()
  }

  ngOnInit() {
    this.titleService.updateTitle();
  }
}
